import Keycloak from 'keycloak-js'

const constructorInitOptions = {
  url: 'https://auth.powertrip.earth/auth',
  realm:
    document?.querySelector('powertrip-powersell')?.attributes?.['realm' as any]?.nodeValue ??
    'powertrip',
  clientId: 'optimiser',
}

const keycloak = new Keycloak(constructorInitOptions)

export default keycloak
